import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";

export const ElFooter = styled.footer`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: sticky;
  top: 0;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
  z-index: 999999;
  background-color: #fff;
`;

export const ElFooterContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2em;
  ${isMobile} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2em 0;
  }
`;

export const ElDescription = styled.p`
  color: #000;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 36px */
  ${String(isMobile)} {
    text-align: center;
  }
`;
export const EllogoLink = styled.a`
  gap: 20px;
`;

export const EllogoImg = styled.img`
  height: 45px;
  width: auto;
`;

export const ElMenu = styled.ul`
  /* width: 100%; */
  display: flex;
  padding: 0;
  gap: 30px;
`;

export const ElMenuLeft = styled.div`
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 30px;
  width: 50%;
  ${isMobile} {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ElMenuItem = styled.li`
  display: flex;
`;

export const ElAnchor = styled.a`
  /* display: flex; */

  font-size: 14px;
  color: var(--theme-main-flat-dark-color);
  padding: 15px 0;
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;

  &:hover {
    color: var(--theme-hover-color);
    opacity: 0.8;
  }
`;

export const ElAnchorButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--theme-main-flat-color);
  border: 1px solid var(--theme-main-color);
  background-color: var(--theme-main-color);
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  padding: 12px 24px;
  border-radius: 3px;
  &:hover {
    color: var(--theme-hover-color);
    background-color: var(--theme-main-flat-color);
  }
`;
